import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL, USER_URL } from '../../constant/api';
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import { BsPersonFill } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SellerProfile() {
  const [profileData, setProfileData] = useState({
    personal: {
      username: '',
      email: '',
      mobile_number: ''
    },
    company: {
      company_name: '',
      location: '',
      company_mail: '',
      logo: null
    }
  });
  const [editingData, setEditingData] = useState({
    personal: {
      username: '',
      email: '',
      mobile_number: ''
    },
    company: {
      company_name: '',
      location: '',
      company_mail: '',
      logo: null
    }
  });
  const [isLoading, setIsLoading] = useState(true);

  // Fetch data on component mount
  useEffect(() => {
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    try {
      const response = await USER_URL.get('/accounts/seller/company/');
      
      
      const data = response.data.Data;
      console.log(data);
      
      
      setProfileData({
        personal: {
          username: data.username || '',
          email: data.email || '',
          mobile_number: data.mobile_number || ''
        },
        company: {
          company_name: data.company_name || '',
          location: data.location || '',
          company_mail: data.company_mail || '',
          logo: data.logo || null
        }
      });

      setEditingData({
        personal: {
          username: data.username || '',
          email: data.email || '',
          mobile_number: data.mobile_number || ''
        },
        company: {
          company_name: data.company_name || '',
          location: data.location || '',
          company_mail: data.company_mail || '',
          logo: data.logo || null
        }
      });
    } catch (error) {
      console.error('Error fetching profile data:', error);
      toast.error("Failed to fetch profile data");
    } finally {
      setIsLoading(false);
    }
  }; 

  const handlePersonalChange = (e) => {
    const { name, value } = e.target;
    setEditingData(prev => ({
      ...prev,
      personal: {
        ...prev.personal,
        [name]: value
      }
    }));
  };

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setEditingData(prev => ({
      ...prev,
      company: {
        ...prev.company,
        [name]: value
      }
    }));
  };

  const handleLogoChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setEditingData(prev => ({
        ...prev,
        company: {
          ...prev.company,
          logo: file
        }
      }));
    }
  };

  const saveProfileData = async () => {
    try {
      const formData = new FormData();
      
      // Append personal info
      formData.append('username', editingData.personal.username);
      formData.append('email', editingData.personal.email);
      formData.append('mobile_number', editingData.personal.mobile_number);
      
      // Append company info
      formData.append('company_name', editingData.company.company_name);
      formData.append('company_mail', editingData.company.company_mail);

      formData.append('location', editingData.company.location);
     
      if (editingData.company.logo instanceof File) {
        formData.append('logo', editingData.company.logo);
      }

      await USER_URL.patch('/accounts/seller/company/', formData);
      toast.success("Profile updated successfully");
      fetchProfileData();
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error("Failed to update profile");
    }
  };

  if (isLoading) {
    return <div className="flex justify-center items-center min-h-screen">Loading...</div>;
  }

  return (
    <div>
      <div className="min-h-screen flex items-center justify-center bg-cover bg-no-repeat" style={{ backgroundImage: "url('/images/profile/BImage.png')" }}>
       

        {/* Back Button */}
        <button 
          onClick={() => window.history.back()} 
          className="absolute top-4 left-4 bg-white text-black p-2 rounded-full shadow-md hover:bg-gray-100 flex items-center justify-center"
        >
          <FaArrowLeft className="text-lg" />
        </button>

        <div className="w-11/12 max-w-6xl flex flex-col md:flex-row gap-5 p-4">
          {/* Profile Details Card (Left side) */}
          <div className="w-full md:w-1/4 bg-white p-6 shadow-lg rounded-lg">
            <h3 className="text-lg font-bold text-green-600">Personal Details</h3>
            <div className="w-20 h-20 bg-yellow-300 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer mt-5 mb-5">
              <BsPersonFill className="text-gray-500 size-16" />
            </div>
            <div className='ml-2'>
              <p className="text-sm font-semibold text-gray-700 py-1">{profileData.personal.username}</p>
              <p className="text-sm font-semibold text-gray-700 py-1">{profileData.personal.mobile_number}</p>
              <p className="text-sm font-semibold text-gray-700 py-1">{profileData.personal.email}</p>

              <hr className="my-6" />

              <h3 className="text-lg font-bold text-green-600">Company Details</h3>
              <p className="text-sm mt-2 font-semibold text-gray-700 py-1">{profileData.company.company_name}</p>
              <p className="text-sm font-semibold text-gray-700 py-1">{profileData.company.location}</p>
              <p className="text-sm font-semibold text-gray-700 py-1">{profileData.company.company_mail}</p>
              {profileData.company.logo ? (
                <img
                  src={
                    profileData.company.logo instanceof File
                      ? URL.createObjectURL(profileData.company.logo)
                      : `${BASE_URL}${profileData.company.logo}`
                  }
                  alt="Company Logo"
                  className="w-20 h-20 mt-5 rounded-md"
                />
              ) : (
                <div className="w-20 h-20 rounded-md bg-gray-200 flex items-center justify-center mt-5">
                  <span>No Logo</span>
                </div>
              )}
            </div>
          </div>

          {/* Edit Details Card (Right Side) */}
          <div className="w-full md:w-3/4 bg-white p-6 shadow-lg rounded-lg">
            <div className="space-y-10">
              {/* Personal Info */}
              <div>
                <div className="flex justify-between items-center">
                  <h4 className="font-bold text-lg text-green-600">Personal Info</h4>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                <div>
  <label className="text-sm font-semibold">Username</label>
  <input 
    type="text" 
    name="username" 
    value={editingData.personal.username} 
    readOnly
    className="p-3 border border-gray-300 rounded-md w-full font-medium text-sm bg-gray-100 cursor-not-allowed" 
  />
</div>

                  <div>
                    <label className="text-sm font-semibold">Email</label>
                    <input 
                      type="email" 
                      name="email" 
                      value={editingData.personal.email} 
                      onChange={handlePersonalChange} 
                      className="p-3 border border-gray-300 rounded-md w-full text-sm" 
                    />
                  </div>
                  <div>
                    <label className="text-sm font-semibold">Phone Number</label>
                    <input 
                      type="text" 
                      name="mobile_number" 
                      value={editingData.personal.mobile_number} 
                      onChange={handlePersonalChange} 
                      className="p-3 text-sm border border-gray-300 rounded-md w-full" 
                    />
                  </div>
                </div>
              </div>

              {/* Company Info */}
              <div>
                <div className="flex justify-between items-center">
                  <h4 className="font-bold text-lg text-green-600">Company Info</h4>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                  <div>
                    <label className="text-sm font-semibold">Company Name</label>
                    <input
                      type="text"
                      name="company_name"
                      value={editingData.company.company_name}
                      onChange={handleCompanyChange} 
                      className="p-3 text-sm border border-gray-300 rounded-md w-full" 
                    />
                  </div>
                  <div>
                    <label className="text-sm font-semibold">Location</label>
                    <input 
                      type="text" 
                      name="location" 
                      value={editingData.company.location} 
                      onChange={handleCompanyChange} 
                      className="p-3 text-sm border border-gray-300 rounded-md w-full" 
                    />
                  </div>
                  <div>
                    <label className="text-sm font-semibold">Company Mail</label>
                    <input
                      type="email"
                      name="company_mail"
                      value={editingData.company.company_mail}
                      onChange={handleCompanyChange} 
                      className="p-3 text-sm border border-gray-300 rounded-md w-full" 
                    />
                  </div>

                  {/* Company Logo Upload */}
                  <div className="flex items-center gap-5 lg:gap-16">
                    {editingData.company.logo ? (
                      <img 
                        src={
                          editingData.company.logo instanceof File
                            ? URL.createObjectURL(editingData.company.logo)
                            : `${BASE_URL}${editingData.company.logo}`
                        } 
                        alt="Company Logo" 
                        className="w-16 h-16 rounded-md object-cover border border-gray-300" 
                      />
                    ) : (
                      <div className="w-16 h-16 bg-gray-200 flex items-center justify-center rounded-md">
                        <span className="text-sm text-gray-500">No Logo</span>
                      </div>
                    )}

                    <label className="flex items-center cursor-pointer text-sm text-white bg-blue-500 px-4 py-2 rounded-md hover:bg-blue-600">
                      <FaCloudUploadAlt className="mr-2 text-lg" />
                      Upload Logo
                      <input 
                        type="file" 
                        onChange={handleLogoChange} 
                        className="hidden" 
                        accept="image/*" 
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Save Button */}
              <div className="flex justify-end">
                <button 
                  onClick={saveProfileData} 
                  className="bg-green-500 text-white px-6 py-2 rounded-md text-sm sm:text-base hover:bg-green-600"
                >
                  Save All Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SellerProfile;